import BaseService from './BaseService'
import servicesConfig from '../config/services'
import { pickBy } from 'lodash'

class NotificationService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getPreferences = (locationId: string, userId: string) => this.requests.get(`/preferences/locations/${locationId}/users/${userId}`)
  savePreference = (locationId: string, userId: string, preferences) => this.requests.post(`/preferences`, {userId, locationId, preferences})

  getByUserIdAndLocations = (queryData: { [key: string]: any }) =>{
    const bodyData = pickBy(queryData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.post(`/`,bodyData)
  }
  getByUserId = (userId: string, queryData: { [key: string]: any }) =>{
    const params = pickBy(queryData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.get(`/users/${userId}`,{params})
  }
  update = (id: string, data: { [key: string]: any }) => this.requests.put(`/${id}`, data)

  updateByUserId = (userId: string, bodyData: { [key: string]: any }) =>{
    const body = pickBy(bodyData, v => v !== null && v !== undefined && v !== '' )
    return this.requests.put(`/users/${userId}`,body)
  }

  deleteByUserId = (userId: string) =>{
    return this.requests.delete(`/users/${userId}`)
  }

}

const instance = new NotificationService(servicesConfig.Notification)

export default instance
